import { IcdCorporationManager, IcdCorporationManagerRM } from "@herbjoy/apex-api-models";
import { IHttpService } from "angular";

export class PromotingOwnerService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject';
    }

    retrievePromotingOwners(query?: { showRegisteredPromotingOwner: boolean }) {
        return this.$http<IcdCorporationManagerRM[]>({
            method: "GET",
            params: query,
            url: this.apexApiUrl + "promoting-owners"
        })
            .then(response => {
                return response.data;
            });
    }

    retrievePromotingOwner(promotingOwnerID: number) {
        return this.$http<IcdCorporationManagerRM>({
            method: "GET",
            url: this.apexApiUrl + "promoting-owners/" + promotingOwnerID
        })
            .then(response => {
                return response.data;
            });
    }

    savePromotingOwner(promotingOwner: IcdCorporationManager) {
        if (!promotingOwner.IsNew) {
            return this.$http<void>({
                method: "PUT",
                url: this.apexApiUrl + "promoting-owners/" + promotingOwner.Id,
                data: JSON.stringify(promotingOwner),
                headers: { "Content-Type": "application/json" }
            })
                .then(() => {
                    return promotingOwner;
                });
        } else {
            return this.$http<IcdCorporationManagerRM>({
                method: "POST",
                url: this.apexApiUrl + "promoting-owners",
                data: JSON.stringify(promotingOwner),
                headers: { "Content-Type": "application/json" }
            })
                .then(response => {
                    return response.data;
                });
        }
    }

    deletePromotingOwner(promotingOwnerID: number) {
        return this.$http<IcdCorporationManagerRM>({
            method: "DELETE",
            url: this.apexApiUrl + "promoting-owners/" + promotingOwnerID,
            headers: {
                "Content-Type": "application/json"
            },
            data: {}
        });
    }
}
